export default __webpack_public_path__ + "19b4bec742e23fde4485dcfb1a220038.png";